import { useState } from "react";
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { LucidePlus } from "lucide-react";
import CustomSelect from "../../../../../../../../../components/select/default/v1/CustomSelect";
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import { v4 as uuidv4 } from 'uuid';
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";
import { useCreatePurchaseInfoMutation } from "../../../../../../Data/purchaseInfosReactQuery/PurchaseInfosReactQuery";
import { CustomLabelTextarea } from "../../../../../../../../../components/textarea/CustomLabelTextarea";

const StyledBody = styled.div`
    padding: 10px;
    min-height: 100vh;
`;

const StyledPurchaseRoute = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;

    .purchase-route-option{
        padding: 5px 10px;
        border: none;
        border-radius: 5px;
        background-color: var(--backgroundField);
        cursor: pointer;
        transition: background 0.2s;
        font-weight: 500;


        &.selected{
            background-color: #333;
            color: #fff;
            font-weight: 600;
        }

        &:hover{
            box-shadow: var(--shadow-sm);
            /* scale: 1.02; */
        }
    }
`;

const StyledFormField = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;

    .input-box{
        input{
            background-color: #fff;
            border-color: #efefef;
            border-radius: 5px;

            &:focus{
                border-color: #333;
            }
        }
    }

    .textarea-box{
        background-color: #fff;
        border-color: #efefef;
        border-radius: 5px;
    }

    .footer{
        width: 100px;
        margin-left: auto;

        button{
            background-color: var(--primary);
            color: #fff;
            font-weight: 600;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            transition: all 0.2s;
            &:hover{
                box-shadow: var(--shadow-sm);
                scale: 1.02;
            }

        }
    }
`;

export function FragmentAdd({
    onClose,
    targetPurchaseInfos,
    productOptionDetail,
    PURCHASE_ROUTE_OPTIONS,
    setViewType,
}) {
    const [newPurchaseInfo, setNewPurchaseInfo] = useState({
        uuid: uuidv4(),
        name: '',
        purchaseUrl: '',
        offerId: '',
        offerName: '',
        specId: '',
        specName: '',
        purchaseRoute: '1688',
        purchaseRouteMemo: '',
        productOptionId: productOptionDetail?.productOptionDto?.id,
        defaultFlag: false,
    });

    const createPurchaseInfoMutation = useCreatePurchaseInfoMutation();

    const handleSubmit = () => {
        if (!newPurchaseInfo?.name || newPurchaseInfo?.name?.length < 1 || newPurchaseInfo?.name?.length > 100) {
            customToast.error('구매정보는 1자 이상 100자 이하로 입력해주세요.');
            return;
        }

        const defaultFlag = !targetPurchaseInfos || targetPurchaseInfos?.length <= 0 ? true : false;

        createPurchaseInfoMutation.mutate({
            body: {
                payload: {
                    ...newPurchaseInfo,
                    defaultFlag: defaultFlag,
                }
            }
        }, {
            onSuccess: (data) => {
                setViewType('DEFAULT');
            }
        });
    }

    return (
        <>
            <CustomDialog.Header style={{ padding: 10 }}>
                <CustomDialog.Header.Back onClick={() => setViewType('DEFAULT')} />
                <CustomDialog.Header.Title>
                    <div className='text-center'>
                        <span>구매정보</span>
                        <div className='font-extrabold text-lg mt-1'>
                            {productOptionDetail?.productDto?.name} / {productOptionDetail?.productOptionDto?.name}
                        </div>
                    </div>
                </CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose()} />
            </CustomDialog.Header>
            <StyledBody>
                <StyledFormField onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}>
                    <StyledPurchaseRoute>
                        {PURCHASE_ROUTE_OPTIONS?.filter(r => r.value !== 'ALL')?.map(purchaseRouteOption => {
                            const isSelected = newPurchaseInfo?.purchaseRoute === purchaseRouteOption.value;
                            return (
                                <div
                                    key={purchaseRouteOption.value}
                                    className={`purchase-route-option ${isSelected ? 'selected' : ''}`}
                                    onClick={() => {
                                        setNewPurchaseInfo(prev => {
                                            return {
                                                ...prev,
                                                purchaseRoute: purchaseRouteOption.value
                                            }
                                        })
                                    }}
                                >
                                    {purchaseRouteOption.label}
                                </div>
                            )
                        })}
                    </StyledPurchaseRoute>
                    <CustomLabelInput
                        type="text"
                        className='input-box'
                    >
                        <CustomLabelInput.Input
                            type='text'
                            value={newPurchaseInfo?.name || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setNewPurchaseInfo(prev => {
                                    return {
                                        ...prev,
                                        name: value
                                    }
                                })
                            }}
                        />
                        <CustomLabelInput.Label><span style={{ color: 'var(--destructive)' }}>*</span> 구매정보 (1~100자 입력)</CustomLabelInput.Label>
                    </CustomLabelInput>
                    <CustomLabelInput
                        type="text"
                        className='input-box'
                    >
                        <CustomLabelInput.Input
                            type='text'
                            value={newPurchaseInfo?.purchaseUrl || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setNewPurchaseInfo(prev => {
                                    return {
                                        ...prev,
                                        purchaseUrl: value
                                    }
                                })
                            }}
                        />
                        <CustomLabelInput.Label>구매 URL</CustomLabelInput.Label>
                    </CustomLabelInput>
                    {newPurchaseInfo?.purchaseRoute === '1688' && (
                        <>
                            <CustomLabelInput
                                type="text"
                                className='input-box'
                            >
                                <CustomLabelInput.Input
                                    type='text'
                                    value={newPurchaseInfo?.offerId || ''}
                                    onChange={(e) => {
                                        const raw = e.target.value;
                                        // 개행 기준 분리
                                        const parts = raw.split(/\r?\n/);
                                        const offerPart = parts[0] ?? '';
                                        const specPart = parts[1]?.trim();
                                        setNewPurchaseInfo(prev => {
                                            return {
                                                ...prev,
                                                offerId: offerPart.trim(),
                                                specId: specPart ? specPart : prev.specId // 두 번째 줄이 있으면 specId 갱신
                                            }
                                        });
                                    }}
                                    onPaste={(e) => {
                                        // 붙여넣기 시 여러 줄 빠르게 처리
                                        const text = (e.clipboardData || window.clipboardData).getData('text');
                                        if (text.includes('\n')) {
                                            e.preventDefault();
                                            const [offerPart, specPart] = text.split(/\r?\n/);
                                            setNewPurchaseInfo(prev => ({
                                                ...prev,
                                                offerId: (offerPart || '').trim(),
                                                specId: (specPart || '').trim()
                                            }));
                                        }
                                    }}
                                />
                                <CustomLabelInput.Label>offerId (여기다 붙여넣기)</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput
                                type="text"
                                className='input-box'
                            >
                                <CustomLabelInput.Input
                                    type='text'
                                    value={newPurchaseInfo?.specId || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setNewPurchaseInfo(prev => {
                                            return {
                                                ...prev,
                                                specId: value
                                            }
                                        })
                                    }}

                                />
                                <CustomLabelInput.Label>specId</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput
                                type="text"
                                className='input-box'
                            >
                                <CustomLabelInput.Input
                                    type='text'
                                    value={newPurchaseInfo?.offerName || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setNewPurchaseInfo(prev => {
                                            return {
                                                ...prev,
                                                offerName: value
                                            }
                                        })
                                    }}
                                />
                                <CustomLabelInput.Label>offer 이름</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <CustomLabelInput
                                type="text"
                                className='input-box'
                            >
                                <CustomLabelInput.Input
                                    type='text'
                                    value={newPurchaseInfo?.specName || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setNewPurchaseInfo(prev => {
                                            return {
                                                ...prev,
                                                specName: value
                                            }
                                        })
                                    }}
                                />
                                <CustomLabelInput.Label>spec 이름</CustomLabelInput.Label>
                            </CustomLabelInput>
                        </>
                    )}
                    <div className='footer'>
                        <CustomBlockButton
                            type='submit'
                            color="primary"
                        >
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <LucidePlus size={16} style={{ marginRight: 5 }} />
                                추가
                            </div>
                        </CustomBlockButton>
                    </div>
                </StyledFormField>
            </StyledBody>
        </>
    );
}



/**
 * _id: mongoose.Types.ObjectId;
    uuid: string;
    workspaceId: string;
    productOptionId: string;
    defaultPurchaseInfo: Object;
    purchaseInfos: Array<Object>;

    uuid: string;
    purchaseUrl: string;
    memo: string;
    offerId: string;
    specId: string;
    specName: string;
    purchaseRoute: string; // 1688, TAOBAO, ETC
    purchaseRouteMemo: string;
 */
const MOCK_DATA = {
    _id: "64b8f4f4f4f4f4f4f4f4f4f",
    uuid: "123e4567-e89b-12d3-a456-426614174000",
    workspaceId: "workspace_001",
    productOptionId: "product_option_001",
    defaultPurchaseInfo: {
        purchaseUrl: "https://www.1688.com/offer/1234567890.html",
        memo: "기본 구매 정보 메모",
        offerId: "offer_001",
        specId: "spec_001",
        specName: "기본 스펙 이름",
        purchaseRoute: "1688", // 1688, TAOBAO, ETC
        purchaseRouteMemo: "기본 구매 경로 메모"
    },
    purchaseInfos: [
        {
            uuid: "info_001",
            purchaseUrl: "https://www.1688.com/offer/1234567890.html",
            memo: "첫 번째 구매 정보 메모",
            offerId: "offer_001",
            offerName: "오퍼 이름 1",
            specId: "spec_001",
            specName: "스펙 이름 1",
            purchaseRoute: "1688", // 1688, TAOBAO, ETC
            purchaseRouteMemo: "첫 번째 구매 경로 메모"
        },
        {
            uuid: "info_002",
            purchaseUrl: "https://item.taobao.com/item.htm?id=9876543210",
            memo: "두 번째 구매 정보 메모",
            offerId: "offer_002",
            offerName: "오퍼 이름 2",
            specId: "spec_002",
            specName: "스펙 이름 2",
            purchaseRoute: "TAOBAO", // 1688, TAOBAO, ETC
            purchaseRouteMemo: "두 번째 구매 경로 메모"
        },
        {
            uuid: "info_003",
            purchaseUrl: "https://www.example.com/product/12345",
            memo: "세 번째 구매 정보 메모",
            offerId: "offer_003",
            offerName: "오퍼 이름 3",
            specId: "spec_003",
            specName: "스펙 이름 3",
            purchaseRoute: "ETC", // 1688, TAOBAO, ETC
            purchaseRouteMemo: "세 번째 구매 경로 메모"
        }
    ]
}